/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Days_Per_WeekInputs */

const en_us2_profile_days_per_week = /** @type {(inputs: Profile_Days_Per_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 day a week`);
	return /** @type {LocalizedString} */ (`${i?.count} days a week`)
	
};

const pt_br2_profile_days_per_week = /** @type {(inputs: Profile_Days_Per_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 dia por semana`);
	return /** @type {LocalizedString} */ (`${i?.count} dias por semana`)
	
};

const es_419_profile_days_per_week = /** @type {(inputs: Profile_Days_Per_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 día por semana`);
	return /** @type {LocalizedString} */ (`${i?.count} días por semana`)
	
};

const pt_pt2_profile_days_per_week = /** @type {(inputs: Profile_Days_Per_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 dia por semana`);
	return /** @type {LocalizedString} */ (`${i?.count} dias por semana`)
	
};

const fr_fr2_profile_days_per_week = /** @type {(inputs: Profile_Days_Per_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 jour par semaine`);
	return /** @type {LocalizedString} */ (`${i?.count} jours par semaine`)
	
};

const de_de2_profile_days_per_week = /** @type {(inputs: Profile_Days_Per_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Tag pro Woche`);
	return /** @type {LocalizedString} */ (`${i?.count} Tage pro Woche`)
	
};

const it_it2_profile_days_per_week = /** @type {(inputs: Profile_Days_Per_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 giorno a settimana`);
	return /** @type {LocalizedString} */ (`${i?.count} giorni a settimana`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 day a week" |
* | * | "{count} days a week" |
*
* @param {Profile_Days_Per_WeekInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_days_per_week = /** @type {((inputs: Profile_Days_Per_WeekInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Days_Per_WeekInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_days_per_week(inputs)
	if (locale === "es-419") return es_419_profile_days_per_week(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_days_per_week(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_days_per_week(inputs)
	if (locale === "de-DE") return de_de2_profile_days_per_week(inputs)
	if (locale === "it-IT") return it_it2_profile_days_per_week(inputs)
	return en_us2_profile_days_per_week(inputs)
});
export { profile_days_per_week as "profile.days_per_week" }